// extracted by mini-css-extract-plugin
export default {"row":"d8W1hHvNXoKWglP8ezrp"};